import { z } from 'zod';
import { ONBOARDING_EMAIL_KEYS } from '../email-template.js';

// The configured uIT signer / notification email (T-040). The GET response may
// carry '' when it hasn't been set yet; updates require a valid email.
export const UitSignerEmailResponse = z.object({
  uit_signer_email: z.string(),
});
export type UitSignerEmailResponse = z.infer<typeof UitSignerEmailResponse>;

export const UitSignerEmailUpdateInput = z.object({
  uit_signer_email: z.string().email(),
});
export type UitSignerEmailUpdateInput = z.infer<typeof UitSignerEmailUpdateInput>;

// Editable post-signature onboarding emails (T-098). GET returns the effective
// (custom-or-default) subject + markdown body per email; PATCH stores a custom
// override; DELETE clears it back to the default.
export const OnboardingEmailTemplateSchema = z.object({
  subject: z.string().min(1).max(200),
  body: z.string().min(1).max(20000),
});
export type OnboardingEmailTemplateDTO = z.infer<typeof OnboardingEmailTemplateSchema>;

export const OnboardingEmailsResponse = z.object({
  invite: OnboardingEmailTemplateSchema,
  post_sig_1: OnboardingEmailTemplateSchema,
  post_sig_2: OnboardingEmailTemplateSchema,
  // The real {{signatoryName}} value (MAIL_FROM_NAME) so the Settings preview
  // matches what is sent — not a hardcoded sample (T-099).
  signatoryName: z.string(),
});
export type OnboardingEmailsResponse = z.infer<typeof OnboardingEmailsResponse>;

export const OnboardingEmailUpdateInput = z.object({
  emailKey: z.enum(ONBOARDING_EMAIL_KEYS),
  subject: z.string().min(1).max(200),
  body: z.string().min(1).max(20000),
});
export type OnboardingEmailUpdateInput = z.infer<typeof OnboardingEmailUpdateInput>;
